// removed by extract-text-webpack-plugin
module.exports = {"a-price":"_3wjyG7g4P1X7ymHb04Wzjw","a-bold-price":"_2gXA1uL_ObtfV06m6bLLfW"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/Price/style.scss
// module id = 913
// module chunks = 0